<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { cn } from '#ui-kit/lib/utils'

const props = defineProps<{
  class?: HTMLAttributes['class']
}>()
</script>

<template>
  <td data-slot="table-cell" :class="cn('h-[inherit] align-middle font-display text-xs text-primal', props.class)">
    <slot />
  </td>
</template>
